import styled from 'styled-components'
import { Skeleton } from 'antd'

const AntSkeletonStyled = styled(Skeleton)``

export default AntSkeletonStyled
